var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeamlessWorking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_31808)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_437_31808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5007 14.5833C24.8567 14.5833 24.334 14.0607 24.334 13.4167V11.6667H19.6673V13.4167C19.6673 14.0607 19.1447 14.5833 18.5007 14.5833C17.8567 14.5833 17.334 14.0607 17.334 13.4167V11.6667C17.334 10.3798 18.3805 9.33334 19.6673 9.33334H24.334C25.6208 9.33334 26.6673 10.3798 26.6673 11.6667V13.4167C26.6673 14.0607 26.1447 14.5833 25.5007 14.5833Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8283 24.9433C22.6183 25.025 22.315 25.0833 22 25.0833C21.685 25.0833 21.3817 25.025 21.1017 24.92L8 20.5567V29.4583C8 31.2317 9.435 32.6667 11.2083 32.6667H32.7917C34.565 32.6667 36 31.2317 36 29.4583V20.5567L22.8283 24.9433Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 16.0417V18.7133L22.28 23.2867C22.1867 23.3217 22.0933 23.3333 22 23.3333C21.9067 23.3333 21.8133 23.3217 21.72 23.2867L8 18.7133V16.0417C8 14.2683 9.435 12.8333 11.2083 12.8333H32.7917C34.565 12.8333 36 14.2683 36 16.0417Z",
    fill: "#00994E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_31808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(7.5 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_437_31808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamlessWorking);
export default __webpack_public_path__ + "static/media/SeamlessWorking.02d43d3f281e5bc56e1288987fae2e1d.svg";
export { ForwardRef as ReactComponent };